import React from 'react';

export default function NoData() {
  return (
    <div className="py-5 border-bottom w-100 text-gray-700 text-center">
      <h2>Member does not have any assessments</h2>

      <div className="mb-4">Please add assessment!</div>
    </div>
  );
}
